export const API_BASE_URL =
  (import.meta.env.VITE_API_BASE_URL as string | undefined) || 'http://localhost:3001/v1';

export const STORAGE_KEYS = {
  accessToken: 'mt-backoffice:access-token',
  refreshToken: 'mt-backoffice:refresh-token',
  user: 'mt-backoffice:user'
};
